import React, { useMemo } from 'react'

import { Dashboard, DashboardPermissionGuard, PageLayout } from '@components'
import {
  Button,
  ButtonGroup,
  HeadContent,
  Pagination,
  ToolbarButton,
  useMediaQueryContext,
  usePagination,
} from '@fourthwall/components'
import { PlusIcon } from '@fourthwall/icons'
import { routing } from '@utils/routing'

import { ALL_COLLECTION_SLUG } from '../../../consts/collection'
import { CollectionsData } from './components/CollectionsData'
import { useCollectionsQuery } from './queries/useCollectionsQuery'

export const Collections = () => {
  const media = useMediaQueryContext()
  const [currentPage, setCurrentPage] = usePagination()
  const { collectionsQuery } = useCollectionsQuery([
    {
      page: currentPage - 1,
      size: 20,
    },
  ])
  const totalPages = collectionsQuery.data?.totalPages

  const collections = useMemo(
    () =>
      collectionsQuery.data?.collections?.filter(
        (collection) => collection.slug !== ALL_COLLECTION_SLUG,
      ),
    [collectionsQuery.data],
  )

  const getToolbarContent = () => {
    if (!media.tablet) {
      return (
        <ButtonGroup space="medium">
          <DashboardPermissionGuard permission="collections.create">
            <ToolbarButton
              label="Create new product"
              icon={PlusIcon}
              to={routing.products.collections.create.self}
            />
          </DashboardPermissionGuard>
        </ButtonGroup>
      )
    }

    return (
      <ButtonGroup space="medium">
        <DashboardPermissionGuard permission="collections.create">
          <Button
            to={routing.products.collections.create.self}
            appearance="primary"
            label="Create new collection"
            size="small"
          />
        </DashboardPermissionGuard>
      </ButtonGroup>
    )
  }

  return (
    <PageLayout size="large">
      <HeadContent title="Collections" />
      <Dashboard.Section name="Collections" toolbarContent={getToolbarContent()}>
        <Dashboard.Section.Item>
          <CollectionsData data={collections || []} isLoading={collectionsQuery.isInitialLoading} />
        </Dashboard.Section.Item>

        {totalPages && totalPages > 0 ? (
          <Dashboard.Section.Item>
            <Pagination
              pageCount={totalPages}
              currentPage={currentPage}
              onChange={setCurrentPage}
            />
          </Dashboard.Section.Item>
        ) : null}
      </Dashboard.Section>
    </PageLayout>
  )
}
